const FEATURE_FLAGS = {
  COMPANY_EVENTS: "company-events",
  FR3028: "fr-3028",
  FR3342: "fr-3342",
  // Here starts new FF keys
  ABSENCES: "omb_absences",
  ORGANIZATION_STRUCTURE: "omb_organization-structure",
  KNOWLEDGE_BASE: "omb_knowledge-base",
  KNOWLEDGE_BASE_SETTINGS: "omb_knowledge-base-settings",
  WALL: "omb_wall",
  DASHBOARD: "omb_dashboard-module",
  PAYROLL_MODULE: "omb_payroll-module",
  ABSENCE_PLANS: "omb_absences_absence-plans",
  DASHBOARD_IMPERSONATE: "omb_dashboard-module_impersonate",
  HIDDED_ABSENCE_TYPE: "omb_absences_hidden-absence-type",
  ABSENCES_MODULE_SETTINGS: "omb_absences_module-settings",
  WALL_MODULE_SETTINGS: "omb_wall_module-settings",
  IMPERSONATED_USER_DETECTION: "omb_impersonated-user-detection",
};

export default FEATURE_FLAGS;
